import { CHART_DIMENSION_PALETTE } from "../../../constants/chartColors";
import type { P4ChartPoint } from "./useP4ChartData";
import styles from "./P4DetailMetricsTableCard.module.css";

interface P4DetailMetricsTableCardProps {
  title: string;
  data: P4ChartPoint[];
  emptyMessage?: string;
  emptyIsWarning?: boolean;
}

const clampPercent = (value: number) => Math.min(100, Math.max(0, value));

const formatPercent = (value: number) => `${value.toFixed(1).replace(/\.0$/, "")}%`;

const formatIndex = (value: number) => value.toFixed(4).replace(/0+$/, "").replace(/\.$/, "");

const MetricCell = ({ value, color }: { value: number; color: string }) => {
  return (
    <div className={styles.metric}>
      <span className={styles.metricValue}>{formatPercent(value)}</span>
      <span className={styles.track} aria-hidden="true">
        <span
          className={styles.bar}
          style={{
            width: `${clampPercent(value)}%`,
            backgroundColor: color,
          }}
        />
      </span>
    </div>
  );
};

const P4DetailMetricsTableCard = ({
  title,
  data,
  emptyMessage = "Sense dades disponibles",
  emptyIsWarning = false,
}: P4DetailMetricsTableCardProps) => {
  return (
    <div className={styles.card} data-chart-card>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.subtitle}>
        Percentatges d'ocupació, adequació i sobrequalificació per entendre el desajust de cada titulació.
      </p>

      {data.length === 0 ? (
        <div className={styles.centered}>
          <span className={emptyIsWarning ? styles.warningNotice : ""}>
            {emptyIsWarning ? `⚠ ${emptyMessage}` : emptyMessage}
          </span>
        </div>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Titulació</th>
                <th>Índex</th>
                <th>Ocupació</th>
                <th>Adequació</th>
                <th>Sobrequalificació</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr key={row.nom_titulacio}>
                  <td className={styles.titleCell}>{row.nom_titulacio}</td>
                  <td>
                    <span className={styles.desajustBadge}>
                      {formatIndex(row.index_desajust)}
                    </span>
                  </td>
                  <td>
                    <MetricCell value={row.taxa_ocupacio_pct} color={CHART_DIMENSION_PALETTE[0]} />
                  </td>
                  <td>
                    <MetricCell value={row.taxa_adequacio_pct} color={CHART_DIMENSION_PALETTE[1]} />
                  </td>
                  <td>
                    <MetricCell value={row.taxa_sobrequalificacio_pct} color={CHART_DIMENSION_PALETTE[2]} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default P4DetailMetricsTableCard;
